import React from "react";
import { PayTypesContext } from "../constants";

export const withPayTypes = Component => {
  return props => (
    <PayTypesContext.Consumer>
      {value => <Component {...props} allPayTypes={value.allPayTypes} />}
    </PayTypesContext.Consumer>
  );
};